import { render, staticRenderFns } from "./VideoAttachment.vue?vue&type=template&id=2d929f8e&scoped=true&"
import script from "./VideoAttachment.vue?vue&type=script&lang=js&"
export * from "./VideoAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d929f8e",
  null
  
)

export default component.exports